
import '../../assets/css/iso-style.css'


const PortfoliIsoTop = ({ portfolioInfo }) => {
    // console.log(portfolioInfo);


    const filtersDefault = portfolioInfo.filtersDefault
    // console.log(filtersDefault);

    const cardsLayout = portfolioInfo.cardsLayout
    // console.log(cardsLayout);



    // console.log("start load data")
    return (
        <>
            <div className="portfolio-iso grid">

                <div id="filters" className="gallery-filters filters position-relative">
                    <button className="item item-button  d-inline-block" data-filter='*'>
                        <span className="d-inline-block text-center">همه</span>
                    </button>
                    {filtersDefault.map((element, index) => {
                        // console.log(card.filter);
                        return (
                            <button key={element.id} className="item item-button  d-inline-block" data-filter={`.${element.label}`}>
                                <span className="d-inline-block text-center">{element.title}</span>
                            </button>
                        );
                    })}
                </div>

                <div className="product-list-box mt-3 mt-sm-0">

                    {cardsLayout.map((card, index) => {
                        var classnames = 'grid-item iso-item col-12 col-sm-6 col-xl-4';
                        // console.log(card.filter);
                        card.filter.map((element, index) => {
                            classnames = classnames + ' ' + element
                            // return classnames;
                        })

                        // console.log(classnames);
                        return (
                            <div key={card.id} className="test">
                                <div className={classnames}>
                                    <div className="portfolio-item position-relative overflow-hidden">
                                        <a href="google.com" className="d-block gallery-item">
                                            <div className="item-img">
                                                <img src={`https://amirsabit.4api.ir/uploads/Work/${card.iso_image}`} title={card.name} alt={card.name} className="img-fluid" />
                                            </div>
                                            <div className="details">
                                                <div className="text">
                                                    <span className="name d-block">{card.name}</span>
                                                    <span className="category d-block">{card.category}</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>

        </>
    )
}

export default PortfoliIsoTop;